<nz-page-header nzTitle="Dashboard List"></nz-page-header>

<div class="row mt-3">
	<div class="col">
		<app-table [data]="data" [headerClass]="'table-info'" [columns]="columnRef" [filters]="[]"
			[loading]="loading" [disablePaging]="false" (onRowClick)="doView($event)"
			(onUpdateRequired)="doFetchResults($event)">
			<ng-template #refOwner let-row="row">
				<td *ngIf="row.agent">
					{{row.agent.username}}
				</td>
				<td *ngIf="!row.agent">
					Not Owned
				</td>
			</ng-template>
			<ng-template #refMain let-row="row">
				<td *ngIf="row.refMain == false">
					Main
				</td>
				<td *ngIf="row.refMain == true">
					Not Main
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
